import React from "react";
import Footer from "../sections/Footer/Footer";
import Navbar from "../components/Navbar/Navbar";
import Sidebar from "../components/SideBar/SideBar";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./Layout.module.css";

export default function DashboardLayout() {
  const { pathname } = useLocation();

  // condition: if route contains "profile"
  const isProfilePage = pathname.toLowerCase().includes("profile");

  return (
    <>
      <Navbar />
      <div className={styles.dashboard}>
        <div className={styles.container}>
          <Sidebar />
          <main
            className={`${styles.main} ${
              isProfilePage ? styles.profileMain : ""
            }`}
          >
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </>
  );
}
